
import { computed, defineComponent, PropType } from 'vue';
import { useStore } from '@/store';
import { Option } from '@/types';
import { Material } from '@/types/app';
import FilterableSelect from '@/components/form-controls/base/FilterableSelect.vue';
import { useVModel } from 'vue-composable';

export default defineComponent({
  name: 'MaterialsSelect',
  emits: ['update:modelValue', 'input'],
  components: {
    FilterableSelect
  },
  props: {
    modelValue: {
      type: Object as PropType<Omit<Material, 'id'>>,
      required: false
    },
    highlightDiv: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean
    }
  },
  setup(props) {
    const store = useStore();
    const materialState = useVModel(props, 'modelValue');
    const materials = computed(() => store.getters.materials.get);

    const materialOptions = computed<Array<Option<Material>>>(() =>
      materials.value.map(material => ({
        label: material.name,
        value: material
      }))
    );

    return {
      materialOptions,
      materialState
    };
  }
});
